import { Column, FormField, InputTextAreaField } from '@tempmee/react';
import { CollapsibleCard } from '../../../../commonComponents';
import { useFormContext } from '../../hooks/useFormContext';
import { CardTitle } from '../CardTitle';
import { useNotes } from './hooks/useNotes';

export const NotesCard = ({ isOpen, onToggle }) => {
  const { setValue, control } = useFormContext();
  const { formValues } = useNotes(control);

  return (
    <CollapsibleCard
      TitleComponent={() => <CardTitle name="Notes" />}
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <Column gap={5} px={20} style={{ marginBottom: 40 }}>
        <FormField label="Notes for Dental Professionals:" optional>
          <InputTextAreaField
            height={80}
            placeholder="Ex: Check in at the front desk."
            value={formValues.notes}
            onChange={(e) => setValue('notes', e.target.value)}
            style={{ border: 'none' }}
          />
        </FormField>
      </Column>
    </CollapsibleCard>
  );
};
